import React, { useState, useEffect } from "react";
import { Modal, Input, Checkbox, Space, Switch } from "antd";

const stepTypeLabels = {
  click_on_element: "Click on element",
  click_on_random_element: "Click on random element from list",
  collect_dl_object: "Collect dataLayer object",
  collect_dl_before_navigation: "Collect dataLayer before navigation",
  date_range_select: "Select date range",
  fill_input_field: "Fill input field",
  go_to_page: "Go to page",
  scroll_to_percentage: "Scroll to depth",
  select_option: "Select dropdown menu option",
  wait_until_element_visible: "Wait until element appear",
};

const SaveAsComponentModal = ({
  visible = false,
  steps = [],
  onConfirm = () => {},
  onCancel = () => {},
}) => {
  const [componentName, setComponentName] = useState("");
  const [selectedStepIds, setSelectedStepIds] = useState([]);
  const [replaceWithRef, setReplaceWithRef] = useState(true);

  // Select all steps by default when modal opens
  useEffect(() => {
    if (visible && steps.length) {
      setSelectedStepIds(steps.map((s) => s.stepId));
      setComponentName("");
      setReplaceWithRef(true);
    }
  }, [visible, steps]);

  const handleToggleStep = (stepId) => {
    setSelectedStepIds((prev) =>
      prev.includes(stepId)
        ? prev.filter((id) => id !== stepId)
        : [...prev, stepId],
    );
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedStepIds(steps.map((s) => s.stepId));
    } else {
      setSelectedStepIds([]);
    }
  };

  const handleOk = () => {
    onConfirm(componentName, selectedStepIds, replaceWithRef);
  };

  const allSelected =
    steps.length > 0 && selectedStepIds.length === steps.length;

  return (
    <Modal
      centered
      open={visible}
      title="Save steps as reusable component"
      onOk={handleOk}
      onCancel={onCancel}
      okText="Save Component"
      okType="saveChanges"
      zIndex={2000}
      okButtonProps={{
        disabled: !componentName.trim() || selectedStepIds.length === 0,
      }}
    >
      <div style={{ marginTop: 16 }}>
        <label style={{ fontWeight: 600, display: "block", marginBottom: 4 }}>
          Component name
        </label>
        <Input
          value={componentName}
          onChange={(e) => setComponentName(e.target.value)}
          placeholder="e.g. Cookie Consent Flow"
        />
      </div>

      <div style={{ marginTop: 16 }}>
        <label style={{ fontWeight: 600, display: "block", marginBottom: 8 }}>
          Select steps to include
        </label>
        <div style={{ marginBottom: 8 }}>
          <Checkbox checked={allSelected} onChange={(e) => handleSelectAll(e.target.checked)}>
            Select all
          </Checkbox>
        </div>
        <div
          style={{
            maxHeight: 250,
            overflowY: "auto",
            border: "1px solid #f0f0f0",
            borderRadius: 4,
            padding: 8,
          }}
        >
          <Space direction="vertical" size={4} style={{ width: "100%" }}>
            {steps.map((step, idx) => {
              const label =
                stepTypeLabels[step?.type] || step?.type || "Unknown";
              const detail = step?.selector || step?.value || "";
              return (
                <Checkbox
                  key={step.stepId}
                  checked={selectedStepIds.includes(step.stepId)}
                  onChange={() => handleToggleStep(step.stepId)}
                >
                  <span style={{ fontSize: "0.9em" }}>
                    <strong>Step {idx + 1}:</strong> {label}
                    {detail ? ` — ${detail}` : ""}
                  </span>
                </Checkbox>
              );
            })}
          </Space>
        </div>
      </div>

      <div
        style={{
          marginTop: 16,
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <Switch
          checked={replaceWithRef}
          onChange={setReplaceWithRef}
        />
        <span style={{ fontSize: "0.9em" }}>
          Replace selected steps with a component reference
        </span>
      </div>
    </Modal>
  );
};

export { SaveAsComponentModal };
export default SaveAsComponentModal;
